export const formatFileSize = (fileSizeBytes: number) => {
    const fileIs1000KbOrBigger = fileSizeBytes >= (1024 * 1000);

    return fileIs1000KbOrBigger ?
        `${(fileSizeBytes / 1024 / 1024).toFixed(2)}MB` :
        `${(fileSizeBytes / 1024).toFixed(2)}KB`;
};
